import { types } from '../types/types';
import { resolveModuleAccessForRole } from '../helpers/activeSpecialistRoleHelper';

const initialState = {
	roleLogin: {
		roles: [],
		haveRole: false, 
		haveOnlyOneRole: false,
		haveMultipleRoles: false,
		roleUnique: {},

		isAdministrator: false,
		roleAdministrator: {},
		isSpecialist: false,
		roleSpecialist: {},
		isRoleSpecialistSelected: false,
		roleSpecialistSelected: {},

		isSpecialistFeeder: false,
		roleSpecialistFeeder: {},
		isEndUser: false,
		roleEndUser: {},
		isEndUserInstitutional: false,
		roleEndUserInstitutional: {},
		isClient:false,
		roleClient: {},

		moduleAccess: [],
		moduleAccessByRole: {},
	},
	roleSelected: {
		roles: [],
		haveRole: false, 
		haveOnlyOneRole: false,
		haveMultipleRoles: false,
		roleUnique: {},

		isAdministrator: false,
		roleAdministrator: {},
		isSpecialist: false,
		roleSpecialist: {},
		isRoleSpecialistSelected: false,
		roleSpecialistSelected: {},

		isSpecialistFeeder: false,
		roleSpecialistFeeder: {},
		isEndUser: false,
		roleEndUser: {},
		isEndUserInstitutional: false,
		roleEndUserInstitutional: {},
		isClient:false,
		roleClient: {},
	},
	userRolesSave: [],
	userRoleSave: {},
	userRoleSpecialistSelected: {}
};

export const userRoleReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.USERROLE_LOGIN:
			return {
				...state,
				roleLogin: action.payload,
			};

		case types.USERROLE_SELECTED:
			return {
				...state,
				roleSelected: action.payload,
			};

		case types.USERROLE_SELECTED_CLEAN:
			return {
				...state,
				roleSelected: initialState.roleSelected,
			};

		case types.USERROLE_START_REGISTER_LIST:
			return {
				...state,
				userRolesSave: action.payload,
			};

		case types.USERROLE_START_REGISTER_CLIENT:
			return {
				...state,
				userRoleSave: initialState.userRoleSave,
			};

		case types.USERROLE_SELECTED_SPECIALIST: {
			const roleLoginSaved = state.roleLogin;
			const moduleAccess = action.payload?.moduleAccess
				?? resolveModuleAccessForRole(roleLoginSaved.moduleAccessByRole, action.payload);
			const { moduleAccess: _ignored, ...roleSelected } = action.payload || {};

			return {
				...state,
				userRoleSpecialistSelected: roleSelected,
				roleLogin: {
					...roleLoginSaved,
					roleSpecialistSelected: roleSelected,
					isRoleSpecialistSelected: true,
					moduleAccess
				}
			};
		}

		default:
			return state;
	}
};
